import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="ai-prompt-document-status"
//
// Pollt für ein noch in Verarbeitung befindliches Kontextdokument (#4842) den
// document_status-Endpoint und tauscht das Status-Badge in der Prompt-Übersicht
// in-place aus, sobald die Extraktion terminal ist ("ready"/"failed") — so muss
// die Übersichtsseite nach dem Speichern nicht mehr manuell neu geladen werden.
//
// Das Badge selbst ist das Controller-Element; die übersetzten Labels und die
// Status-URL kommen serverseitig über data-values rein (kein i18n im JS nötig).
export default class extends Controller {
  static values = {
    url: String,
    readyLabel: String,
    failedLabel: String,
    interval: { type: Number, default: 2000 },
    // ~5 min Gesamtbudget (docling-OCR kann dauern), danach Stopp — reload bleibt Fallback.
    maxAttempts: { type: Number, default: 150 },
  };

  connect() {
    this.attempts = 0;
    this.stopped = false;
    this.schedule();
  }

  disconnect() {
    this.stopped = true;
    if (this.timer) clearTimeout(this.timer);
  }

  schedule() {
    this.timer = setTimeout(() => this.poll(), this.intervalValue);
  }

  async poll() {
    if (this.stopped) return;
    this.attempts += 1;

    try {
      const response = await fetch(this.urlValue, {
        headers: { Accept: "application/json" },
        credentials: "same-origin",
      });
      if (response.ok) {
        const { state } = await response.json();
        if (this.stopped) return;
        if (state === "ready")
          return this.settle("bg-success", this.readyLabelValue);
        if (state === "failed")
          return this.settle("bg-danger", this.failedLabelValue);
      }
    } catch {
      // Netzwerk-/Transientfehler ignorieren und weiter pollen.
    }

    if (!this.stopped && this.attempts < this.maxAttemptsValue) this.schedule();
  }

  settle(badgeClass, label) {
    this.stopped = true;
    this.element.classList.remove("bg-secondary");
    this.element.classList.add(badgeClass);
    // textContent ersetzt etwaige Kind-Elemente (z.B. Spinner) gleich mit.
    this.element.textContent = label;
  }
}
